import {
  DialogContent,
  Button,
  Stack,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import StandardDialog from "./StandardDialog.js";
import VisibilitySelector from "./VisibilitySelector";
import { useEffect, useRef, useState } from "react";
import { useThemeContext } from "../context/themeContext";

function NotesEditorDialog({
  open,
  notes,
  visibility,
  status,
  onSave,
  onClose,
  isFullscreen,
}) {
  const { isTouchDevice } = useThemeContext();
  const [draftNotes, setDraftNotes] = useState(notes || "");
  const [draftVisibility, setDraftVisibility] = useState(visibility);

  // Re-sync draft state whenever the dialog opens so stale values don't persist
  useEffect(() => {
    if (open) {
      setDraftNotes(notes || "");
      setDraftVisibility(visibility);
    }
  }, [open, notes, visibility]);

  const handleSave = () => {
    onSave({
      notes: draftNotes,
      visibility: draftVisibility,
    });
  };

  const notesInputRef = useRef(null);

  return (
    <StandardDialog
      open={open}
      onClose={onClose}
      isFullscreen={isFullscreen}
      TransitionProps={{ onEntered: () => { if (!isTouchDevice) notesInputRef.current?.focus(); } }}
    >
      <DialogContent sx={{ p: 2 }}>
        <Typography
          gutterBottom
          variant="body2"
          sx={{ fontWeight: "bold", mb: 1 }}
        >
          Edit notes
        </Typography>
        <TextField
          inputRef={notesInputRef}
          value={draftNotes}
          onChange={(event) => setDraftNotes(event.target.value)}
          placeholder={
            status === "queued"
              ? "E.g. recommended by, to watch with, etc..."
              : "Add notes"
          }
          multiline
          minRows={3}
          maxRows={8}
          fullWidth
          variant="outlined"
        />
        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }} />
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mt: 1 }}
        >
          <VisibilitySelector
            value={draftVisibility}
            onChange={setDraftVisibility}
            readOnly={false}
          />
          <Stack direction="row" alignItems="center" spacing={1}>
            <Button onClick={onClose} variant="text">
              Cancel
            </Button>
            <Button onClick={handleSave} variant="contained">
              Save
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </StandardDialog>
  );
}

export default NotesEditorDialog;
